var map = {
	"./ALB.png": 3735,
	"./ARG.png": 2960,
	"./AUS.png": 9129,
	"./AUT.png": 6710,
	"./BEL.png": 5069,
	"./BRA.png": 4857,
	"./CAN.png": 5198,
	"./CHN.png": 8189,
	"./COL.png": 1490,
	"./CRC.png": 94,
	"./CRO.png": 8002,
	"./CZE.png": 5504,
	"./DEN.png": 6869,
	"./EGY.png": 2709,
	"./ENG.png": 8840,
	"./ESP.png": 6648,
	"./FIN.png": 1599,
	"./FRA.png": 7309,
	"./GEO.png": 7583,
	"./GER.png": 362,
	"./HAI.png": 874,
	"./HUN.png": 5081,
	"./IRL.png": 5067,
	"./IRN.png": 1561,
	"./ISL.png": 5984,
	"./ITA.png": 6876,
	"./JAM.png": 9288,
	"./JPN.png": 9852,
	"./KOR.png": 3684,
	"./KSA.png": 9195,
	"./MAR.png": 504,
	"./MEX.png": 9694,
	"./MKD.png": 2460,
	"./NED.png": 4401,
	"./NGA.png": 3266,
	"./NOR.png": 5329,
	"./NZL.png": 1928,
	"./PAN.png": 8701,
	"./PER.png": 3133,
	"./PHI.png": 9057,
	"./POL.png": 8845,
	"./POR.png": 5747,
	"./ROU.png": 7986,
	"./RSA.png": 7202,
	"./RUS.png": 7514,
	"./SCO.png": 7405,
	"./SEN.png": 1986,
	"./SRB.png": 7367,
	"./SUI.png": 8413,
	"./SVK.png": 2210,
	"./SVN.png": 2687,
	"./SWE.png": 5691,
	"./TUN.png": 6245,
	"./TUR.png": 3641,
	"./UKR.png": 3634,
	"./URU.png": 8142,
	"./USA.png": 8497,
	"./VIE.png": 3804,
	"./WAL.png": 5720,
	"./XXX.png": 5648,
	"./ZAM.png": 3336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7140;